import { ERROR_TYPES } from '../components/helpers';

export const API_BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? 'https://radar-api.elimiwait.com'
    : process.env.REACT_APP_ENV === 'qa'
    ? 'https://radar-api-qa.elimiwait.com:3579'
    : process.env.REACT_APP_ENV === 'development'
    ? 'https://radar-api-dev.elimiwait.com'
    : 'http://localhost:3579';

const SURVEY_URL = '/1.0/Survey';

export const getSurvey = (surveyKey, stayGuid) => {
  return RadarRequest(
    'GET',
    SURVEY_URL + '?key=' + surveyKey + '&guid=' + stayGuid
  );
};

export const sendSurvey = (survey) => {
  const body = JSON.stringify(survey);
  return RadarRequest('POST', SURVEY_URL + '/response', body);
};

async function logError(errorType, description) {
  const surveySiteSource = 2;
  const api = `${API_BASE_URL}/1.0/Frontend/Error`;
  const payload = {
    Source: surveySiteSource,
    When: new Date().toISOString(),
    Data: `[SS][${errorType}][${description}]`,
  };

  try {
    const response = await fetch(api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error(
        'Failed to log error:',
        response.status,
        await response.text()
      );
    }
  } catch (error) {
    console.error('Network error while logging error:', error);
  }
}

export function authParameters(pdf) {
  return {
    headers: {
      'Content-Type': 'application/json',
    },
  };
}

export const RadarRequest = (method, path, body) => {
  const config = {
    ...authParameters(),
    method,
    body,
  };

  return fetch(API_BASE_URL + path, config)
    .then((response) => {
      return response
        .json()
        .then((x) => {
          if (response.ok) {
            return { data: x };
          } else {
            // Log error when the response is not okay
            logError(
              ERROR_TYPES.REQUEST,
              `Failed API Call: ${method} ${path}, Status: ${
                response.status
              }, Response: ${JSON.stringify(x)}`
            );
            return { error: x };
          }
        })
        .catch((error) => {
          return { data: {} };
        });
    })
    .catch((error) => {
      // Log network error
      logError(
        ERROR_TYPES.NETWORK,
        `Network error for: ${method} ${path}, Error: ${error.message}`
      );
      return { error: error.message };
    });
};
